<template>
    <el-dialog
        title="发票信息修改"
        :visible.sync="myResult"
        :before-close="handleClose"
        custom-class="editInvoice"
    >
        <div class="dialogContent">
            <el-form
                ref="form"
                :model="modifyInfo"
                label-width="120px"
                :rules="rules"
            >
                <el-form-item
                    label="是否需要"
                    prop="is_need"
                    v-if="modifyInfo.is_enable!=1"
                >
                    <el-radio-group
                        v-model="modifyInfo.is_need"
                        size="small"
                        @change="isNeedChange()"
                    >
                        <el-radio :label="1">需要</el-radio>
                        <el-radio :label="0">不需要</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div v-if="modifyInfo.invoice_type!=3">
                    <el-form-item
                        label="发票类型"
                        prop="elec_invoice_type"
                        v-if="modifyInfo.is_need!=0"
                    >
                        <el-radio-group
                            v-model="modifyInfo.elec_invoice_type"
                            size="small"
                            @change="typeChange"
                        >
                            <el-radio :label="1">个人</el-radio>
                            <el-radio :label="2">单位</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item
                        label="发票抬头"
                        prop="invoice_title"
                        v-if="modifyInfo.is_need!=0"
                    >
                        <el-input v-model="modifyInfo.invoice_title"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="纳税人识别号"
                        prop="invoice_tax_no"
                        v-if="modifyInfo.is_need!=0&&modifyInfo.elec_invoice_type==2"
                    >
                        <el-input v-model="modifyInfo.invoice_tax_no"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="邮箱"
                        prop="email"
                        v-if="modifyInfo.is_need!=0"
                    >
                        <el-input
                            v-model="modifyInfo.email"
                            @change="hanleEmailChange"
                        ></el-input>
                    </el-form-item>
                    <div
                        class="moreInfo"
                        v-if="modifyInfo.is_need!=0&&modifyInfo.elec_invoice_type==2"
                    >
                        更多可选项：地址、电话、开户行账号等选填项
                        <span
                            class="moretap"
                            @click="isShow = !isShow"
                            v-if="!isShow"
                        >
                            展开
                            <span class="el-icon-caret-bottom"></span>
                        </span>
                        <span
                            class="moretap"
                            @click="isShow = !isShow"
                            v-if="isShow"
                        >
                            收起
                            <span class="el-icon-caret-top"></span>
                        </span>
                    </div>
                    <div v-if="modifyInfo.is_need!=0&&modifyInfo.elec_invoice_type==2">
                        <el-collapse-transition>
                            <div v-if="isShow">
                                <el-form-item
                                    label="注册地址："
                                    prop="address_info"
                                >
                                    <el-input
                                        :maxlength="80"
                                        v-model="modifyInfo.address_info"
                                        @input="modifyInfo.address_info=$common.matchAdd(modifyInfo.address_info)"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="注册电话："
                                    prop="telephone_info"
                                >
                                    <el-input
                                        :maxlength="20"
                                        @input="modifyInfo.telephone_info=$common.matchTel(modifyInfo.telephone_info)"
                                        v-model="modifyInfo.telephone_info"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="开户银行："
                                    prop="bank"
                                >
                                    <el-input
                                        :maxlength="74"
                                        @input="modifyInfo.bank=$common.matchBank(modifyInfo.bank)"
                                        v-model="modifyInfo.bank"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="银行账号："
                                    prop="bank_account"
                                >
                                    <el-input
                                        :maxlength="26"
                                        @input="modifyInfo.bank_account=$common.matchBankAccount(modifyInfo.bank_account)"
                                        v-model="modifyInfo.bank_account"
                                    ></el-input>
                                </el-form-item>
                            </div>
                        </el-collapse-transition>
                    </div>
                </div>
            </el-form>
        </div>
        <div
            slot="footer"
            class="dialog-footer"
        >
            <el-button @click="handleClose">取消</el-button>
            <el-button
                type="primary"
                @click="editmModifyConfirm"
            >保存</el-button>
        </div>
    </el-dialog>
</template>
<script type="text/ecmascript-6">
export default {
    data: function() {
        var validateCode = (rule, value, callback) => {
            var reg = /^(?!^0*$)([A-Z0-9]{20})$|^(?!^0*$)([A-Z0-9]{17,18})$|^(?!^0*$)([A-Z0-9]{15})$/;
            if (value === "") {
                callback(new Error("请输入纳税人识别号"));
            } else if (!reg.test(value)) {
                callback(new Error("请输入正确纳税人识别号"));
            } else {
                callback();
            }
        };
        var validEmail = (rule, value, callback) => {
            if (value != "") {
                if (this.isEmailChange) {
                    if (this.$common.validEmail(value)) {
                        callback();
                    } else {
                        callback(new Error("邮箱号不正确"));
                    }
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };
        return {
            myResult: this.dialogFormVisible,
            modifyInfo: this.editModifyInfo,
            isShow: false,
            isEmailChange: false,
            rules: {
                invoice_title: [
                    {
                        required: true,
                        message: "请输入发票抬头",
                        trigger: "blur"
                    },
                    {
                        max: 32,
                        message: "超出最大长度32个字符",
                        trigger: "blur"
                    }
                ],
                invoice_tax_no: [
                    {
                        required: true,
                        message: "请输入纳税人识别号",
                        trigger: "blur"
                    },
                    {
                        validator: validateCode,
                        trigger: "blur"
                    }
                ],
                email: [
                    {
                        required: true,
                        message: "请输入邮箱地址",
                        trigger: "blur"
                    },
                    {
                        validator: validEmail,
                        message: "请输入正确的邮箱地址",
                        trigger: "change"
                    }
                ],
                is_need: [
                    {
                        required: true,
                        message: "请选择是否需要发票",
                        trigger: "change"
                    }
                ],
                elec_invoice_type: [
                    {
                        required: true,
                        message: "请选择发票类型",
                        trigger: "blur,change"
                    }
                ]
            }
        };
    },
    props: {
        dialogFormVisible: {
            type: Boolean,
            default: false
        },

        agree: {
            type: Boolean
        },
        editModifyInfo: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    watch: {
        dialogFormVisible(val) {
            this.myResult = val;
            this.isEmailChange = false;
        },
        editModifyInfo(val) {
            this.modifyInfo = val;
        }
    },
    methods: {
        hanleEmailChange() {
            this.isEmailChange = true;
        },
        isNeedChange() {
            if (this.modifyInfo.is_need == 0) {
                this.modifyInfo.elec_invoice_type = "";
                this.modifyInfo.invoice_tax_no = "";
                this.modifyInfo.invoice_title = "";
                this.modifyInfo.email = "";
                this.modifyInfo.address_info = "";
                this.modifyInfo.telephone_info = "";
                this.modifyInfo.bank = "";
                this.modifyInfo.bank_account = "";
            } else {
                this.modifyInfo.elec_invoice_type = this.editModifyInfo.elec_invoice_type;
                this.modifyInfo.invoice_tax_no = this.editModifyInfo.invoice_tax_no;
                this.modifyInfo.invoice_title = this.editModifyInfo.invoice_title;
                this.modifyInfo.email = this.editModifyInfo.email;
                this.modifyInfo.address_info = this.editModifyInfo.address_info;
                this.modifyInfo.telephone_info = this.editModifyInfo.telephone_info;
                this.modifyInfo.bank = this.editModifyInfo.bank;
                this.modifyInfo.bank_account = this.editModifyInfo.bank_account;
            }
        },
        typeChange() {
            if (this.modifyInfo.elec_invoice_type == 1) {
                this.modifyInfo.tax_Number = "";
                this.modifyInfo.address_info = "";
                this.modifyInfo.telephone_info = "";
                this.modifyInfo.bank = "";
                this.modifyInfo.bank_account = "";
            } else {
                this.modifyInfo.tax_Number = this.editModifyInfo.invoice_tax_no;
                this.modifyInfo.address_info = this.editModifyInfo.address_info;
                this.modifyInfo.telephone_info = this.editModifyInfo.telephone_info;
                this.modifyInfo.bank = this.editModifyInfo.bank;
                this.modifyInfo.bank_account = this.editModifyInfo.bank_account;
            }
        },
        handleClose() {
            this.myResult = false;
            this.$emit("on-edit-invoice-result-change");
        },
        editmModifyConfirm() {
            if (this.modifyInfo.elec_invoice_type == 0) {
                this.modifyInfo.elec_invoice_type = "";
            }
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.$emit(
                        "on-edit-invoice-result-change",
                        this.modifyInfo
                    );
                }
            });
        }
    }
};
</script>
<style lang="scss">
.editInvoice {
    width: 800px;
    .el-dialog__body {
        width: 450px;
        margin: 0 auto;
        .moreInfo {
            text-align: right;
            color: #d3d3d3;
            font-size: 12px;
            margin: 10px 0;
            .moretap {
                color: #7e7d7c;
                margin: 0 10px;
            }
        }
    }
    .dialog-footer {
        text-align: center;
    }
}
</style>
